var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramWithoutEllipseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1158",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1158",
    transform: "translate(0.25 -0.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_29",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 29",
    d: "M-211.838,297.333h-16.8a5.3,5.3,0,0,0-5.292,5.292v16.8a5.3,5.3,0,0,0,5.292,5.292h16.8a5.3,5.3,0,0,0,5.292-5.292v-16.8A5.3,5.3,0,0,0-211.838,297.333Zm1.519,3.157.606,0v4.641l-4.628.017-.015-4.641Zm-13.825,7.723a4.812,4.812,0,0,1,3.908-2.009,4.812,4.812,0,0,1,3.907,2.009,4.785,4.785,0,0,1,.914,2.811,4.826,4.826,0,0,1-4.821,4.819,4.824,4.824,0,0,1-4.819-4.819A4.793,4.793,0,0,1-224.145,308.213Zm14.93,11.21a2.626,2.626,0,0,1-2.624,2.624h-16.8a2.626,2.626,0,0,1-2.624-2.624v-11.21h4.088a7.442,7.442,0,0,0-.552,2.811,7.5,7.5,0,0,0,7.487,7.487,7.494,7.494,0,0,0,7.486-7.487,7.471,7.471,0,0,0-.551-2.811h4.088Z",
    transform: "translate(244.915 -286.262)",
    fill: "#d19f46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWithoutEllipseIcon);
export default __webpack_public_path__ + "static/media/instagram_without_ellipse_icon.9d85971c0e5449dae7dad0d15c68d307.svg";
export { ForwardRef as ReactComponent };